import styled from "@emotion/styled";
import { simpleThumbnailClasses } from "@kaltura/mediaspace-shared-ui";
import { buttonClasses, IconButton, ModalContent, Typography } from "@kaltura/ds-react-components";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";

export const StyledSidebar = styled("aside")(({ theme }) => ({
    width: "100%",
    flexGrow: 0,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    alignSelf: "flex-start",

    [theme.breakpoints.up("sm")]: {
        position: "sticky",
        overflow: "hidden",
    },
    [theme.breakpoints.up("md")]: {
        width: 276,
        marginLeft: theme.spacing(4),
        top: theme.spacing(8),
        maxHeight: "100vh",
    },
    "&:focus-visible": VisibleFocusStyle,
}));

export const StyledSidebarMedia = styled("div")(
    ({ theme }) => ({
        width: "100%",
        height: "auto",
        aspectRatio: "16/9",
        [theme.breakpoints.up("sm")]: {
            [`& .${simpleThumbnailClasses.root}, & .kaltura-player-container, & .playkit-player`]: {
                borderRadius: theme.kaltura.shape.roundness2,
            },
        },
        [theme.breakpoints.up("md")]: {
            height: 156,
            aspectRatio: "auto",
        },
    }),
    { label: "SidebarMedia" }
);

export const StyledSidebarContainer = styled("div")(({ theme }) => ({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    margin: theme.spacing(0, 2, 0, 2),
    [theme.breakpoints.up("sm")]: {
        margin: 0,
    },
}));

export const StyledSidebarInnerContainer = styled(
    "div",
    {
        shouldForwardProp: (prop) => prop !== "detailsClassName",
    }
)<{ detailsClassName: string }>(({ theme, detailsClassName }) => ({
    overflow: "visible",
    [`& .${detailsClassName}`]: {
        marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("sm")]: {
        maxHeight: "100vh",
        overflow: "auto",
    },
    [theme.breakpoints.up("md")]: {
        maxHeight: "60vh",
    },
}));

export const CloseButtonWrapper = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
    [`&.${buttonClasses.focusVisible}`]: {
        ...VisibleFocusStyle,
    },
}));

export const CloseButtonMobile = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
    [`svg`]: {
        width: 24,
        height: 24,
    },
}));

export const FullWidthIconButton = styled(IconButton)(({ theme }) => ({
    margin: theme.spacing(0, 2, 0, 2),
    width: "auto",
    [theme.breakpoints.up("sm")]: {
        width: "100%",
        margin: 0,
    },
    [`&.${buttonClasses.focusVisible}`]: {
        outline: "unset",
        outlineOffset: "unset",
        boxShadow: "inset 0 0 0 0 #0000FF,inset 0 0 0 1px #FFFFFF",
    },
}));

export const MediaName = styled(Typography)(({ theme }) => ({
    width: "100%",
    margin: `0 0 ${theme ? theme.spacing(1) : 0} 0`,
}));

export const StyledModalContent = styled(ModalContent)(({ className }) => ({
    [`&.${className}`]: {
        padding: 0,
    },
}));
